import { render, staticRenderFns } from "./SocialStatuseAdd.vue?vue&type=template&id=4f881158&"
import script from "./SocialStatuseAdd.vue?vue&type=script&lang=js&"
export * from "./SocialStatuseAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports